import ModalWrapper from "../../../../components/modal/modal";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";
import "../styles.css";
import { Link } from "react-router-dom";
import encodeSvgWithColor from "../../../../common/utils/encodeSvgWithColor";
import {
  Button,
} from "antd";
import { Icon } from "../../../../components/icon/icon";
import TaskDrawer from "../tasks/task-drawer";
import { useState } from "react";

// const UploadModal = ({ image, isOpen, close }) => {
//   const [isOpenDrawer, setIsOpenDrawer] = useState(false);
//   const [task, setTask] = useState(null);
//   const handleClick = () => {
//     if (image.sourceType === "scenario" && image?.scenario?.scenarioId) {
//     } else if (image.sourceType === "dailyTask") {
//       setTask(image?.subjectTask);
//       setIsOpenDrawer(true);
//     }
//   };

//   const closeDrawer = () => {
//     setIsOpenDrawer(false);
//     setTask(null);
//   };

//   return (
//     <ModalWrapper
//       classNames="upload-modal"
//       wrapClassName="upload-modal"
//       isOpen={isOpen}
//       onCancel={close}
//       okButtonProps={{ style: { display: "none" } }}
//       cancelButtonProps={{ style: { display: "none" } }}
//       styles={{ padding: 0 }}
//       footer={null}
//       width={1105}
//     >
//       <div className="upload-modal-container">
//         <div className="upload-modal-image-container">
//           <LazyLoadImage
//             src={image.signedUrl}
//             alt={image.title}
//             effect="blur"
//             className="upload-modal-image"
//             wrapperClassName="upload-modal-image-wrapper"
//           />
//         </div>
//         <div className="upload-modal-meta">
//           <div className="upload-meta-content">
//             <div className="meta-item">
//               <p className="meta-title">Source</p>
//               {image.sourceType === 'dailyTask' && image.source ? (
//                 <div
//                   className="task-header-link"
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                   }}
//                 >
//                   {image?.subjectTask?.DailyTask.avatar ? (
//                     <div
//                       className="icon-wrapper"
//                       style={{
//                         backgroundColor: image?.subjectTask?.DailyTask.backgroundColor,
//                       }}
//                     >
//                       <img
//                         src={encodeSvgWithColor(image?.subjectTask?.DailyTask.avatar, image?.subjectTask?.DailyTask.avatarColor)}
//                         alt="avatar"
//                       />
//                     </div>
//                   ) : (
//                     <div
//                       className="icon-wrapper"
//                       style={{ display: 'none' }}
//                     />
//                   )}
//                   <div
//                     style={{
//                       marginLeft: image?.subjectTask?.DailyTask.avatar ? '10px' : '0',
//                       textAlign: 'left',
//                       width: image?.subjectTask?.DailyTask.avatar ? 'auto' : '100%',
//                     }}
//                   >
//                     <p>{image.source || 'N/A'}</p>
//                   </div>
//                   <Button
//                     icon={<Icon name="arrow-right" />}
//                     style={{
//                       background: '#fff',
//                       boxShadow: 'none',
//                       marginLeft: 'auto',
//                     }}
//                     onClick={handleClick}
//                   />
//                   <TaskDrawer isOpenDrawer={isOpenDrawer} close={closeDrawer} task={task} />
//                 </div>
//               ) : (
//                 <p>{image.source || 'N/A'}</p>
//               )}
//             </div>
//             { image?.subject?.displayId && (
//                 <div className="meta-item">
//                   <p className="meta-title">Subject ID</p>
//                   <p className="meta-value">
//                     <Link
//                       to={`/subject-management/subject/${image.subjectId}#profile`}
//                       className="subject-link"
//                     >
//                       {image.subject.displayId || "N/A"}
//                     </Link>
//                   </p>
//                 </div>
//               )
//             }
//             <div className="meta-item">
//               <p className="meta-title">Submission date</p>
//               <p className="meta-value">
//                 {moment(image.createdAt).utc().format("DD MMM YYYY, HH:mm")} UTC
//               </p>
//             </div>
//             <div className="meta-item">
//               <p className="meta-title">Date captured</p>
//               <p className="meta-value">
//                 {image.capturedAt
//                   ? moment(image.capturedAt).utc().format("DD MMM YYYY, HH:mm") + " UTC"
//                   : "N/A"}
//               </p>
//             </div>
//             {image.dueDate && (
//               <div className="meta-item">
//                 <p className="meta-title">Due date</p>
//                 <p className="meta-value">
//                   {moment(image.dueDate).utc().format("DD MMM YYYY, HH:mm")} UTC
//                 </p>
//               </div>
//             )}
//             <div className="meta-item">
//               <p className="meta-title">Message</p>
//               <p className="meta-value">{image.message || "N/A"}</p>
//             </div>
//             <div className="meta-item">
//               <p className="meta-title">Title</p>
//               <p className="meta-value">{image.instructionsTitle || "N/A"}</p>
//             </div>
//             <div className="meta-item">
//               <p className="meta-title">Instruction</p>
//               <p className="meta-value">{image.instructions || "N/A"}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </ModalWrapper>
//   );
// };

const UploadModal = ({ image, isOpen, close }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [task, setTask] = useState(null);

  const signedUrl =
    image?.signedUrl ||
    image?.original ||
    image?.url ||
    '';

  const hasMeta = Boolean(
    image?.sourceType ||
    image?.subject ||
    image?.message ||
    image?.instructionsTitle ||
    image?.instructions ||
    image?.createdAt ||
    image?.capturedAt ||
    image?.dueDate
  );
  console.log('IMAGE', image)
  console.log('hasMeta', hasMeta)
  const handleClick = () => {
    if (image?.sourceType === "scenario" && image?.scenario?.scenarioId) {
      // …
    } else if (image?.sourceType === "dailyTask") {
      setTask(image?.subjectTask);
      setIsOpenDrawer(true);
    }
  };

  const closeDrawer = () => {
    setIsOpenDrawer(false);
    setTask(null);
  };

  return (
    <ModalWrapper
      classNames="upload-modal"
      wrapClassName="upload-modal"
      isOpen={isOpen}
      onCancel={close}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ style: { display: "none" } }}
      styles={{ padding: 0 }}
      footer={null}
      width={hasMeta ? 1105 : 900}
    >
      <div className={`upload-modal-container ${hasMeta ? '' : 'only-image'}`}>
        <div className="upload-modal-image-container">
          <LazyLoadImage
            src={signedUrl}
            alt={image?.title || "image"}
            effect="blur"
            className="upload-modal-image"
            wrapperClassName="upload-modal-image-wrapper"
          />
        </div>

        {hasMeta && (
          <div className="upload-modal-meta">
            <div className="upload-meta-content">
              <div className="meta-item">
                <p className="meta-title">Source</p>
                {image.sourceType === 'dailyTask' && image.source ? (
                  <div className="task-header-link" style={{ display: 'flex', alignItems: 'center' }}>
                    {image?.subjectTask?.DailyTask?.avatar ? (
                      <div
                        className="icon-wrapper"
                        style={{ backgroundColor: image?.subjectTask?.DailyTask?.backgroundColor }}
                      >
                        <img
                          src={encodeSvgWithColor(
                            image?.subjectTask?.DailyTask?.avatar,
                            image?.subjectTask?.DailyTask?.avatarColor
                          )}
                          alt="avatar"
                        />
                      </div>
                    ) : (
                      <div className="icon-wrapper" style={{ display: 'none' }} />
                    )}
                    <div
                      style={{
                        marginLeft: image?.subjectTask?.DailyTask?.avatar ? '10px' : '0',
                        textAlign: 'left',
                        width: image?.subjectTask?.DailyTask?.avatar ? 'auto' : '100%',
                      }}
                    >
                      <p>{image.source || 'N/A'}</p>
                    </div>
                    <Button
                      icon={<Icon name="arrow-right" />}
                      style={{ background: '#fff', boxShadow: 'none', marginLeft: 'auto' }}
                      onClick={handleClick}
                    />
                    <TaskDrawer isOpenDrawer={isOpenDrawer} close={closeDrawer} task={task} />
                  </div>
                ) : (
                  <p>{image.source || 'N/A'}</p>
                )}
              </div>

              {image?.subject?.displayId && (
                <div className="meta-item">
                  <p className="meta-title">Subject ID</p>
                  <p className="meta-value">
                    <Link to={`/subject-management/subject/${image.subjectId}#profile`} className="subject-link">
                      {image.subject.displayId || "N/A"}
                    </Link>
                  </p>
                </div>
              )}

              <div className="meta-item">
                <p className="meta-title">Submission date</p>
                <p className="meta-value">
                  {image.createdAt ? moment(image.createdAt).utc().format("DD MMM YYYY, HH:mm") + " UTC" : "N/A"}
                </p>
              </div>

              <div className="meta-item">
                <p className="meta-title">Date captured</p>
                <p className="meta-value">
                  {image.capturedAt ? moment(image.capturedAt).utc().format("DD MMM YYYY, HH:mm") + " UTC" : "N/A"}
                </p>
              </div>

              {image.dueDate && (
                <div className="meta-item">
                  <p className="meta-title">Due date</p>
                  <p className="meta-value">
                    {moment(image.dueDate).utc().format("DD MMM YYYY, HH:mm")} UTC
                  </p>
                </div>
              )}

              <div className="meta-item">
                <p className="meta-title">Message</p>
                <p className="meta-value">{image.message || "N/A"}</p>
              </div>

              <div className="meta-item">
                <p className="meta-title">Title</p>
                <p className="meta-value">{image.instructionsTitle || "N/A"}</p>
              </div>

              <div className="meta-item">
                <p className="meta-title">Instruction</p>
                <p className="meta-value">{image.instructions || "N/A"}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </ModalWrapper>
  );
};

export default UploadModal;